import type { IconData } from '@stacksjs/iconify-core'

export const moneyBill: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 2H0v12h16zM8 6a2 2 0 1 0 0 4a2 2 0 0 0 0-4M4.5 7H2v2h2.5zm7 0H14v2h-2.5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default moneyBill
